/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_ManagementInputs */



/**
* | output |
* | --- |
* | "Subscription Management" |
*
* @param {Subscription_ManagementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_management = /** @type {((inputs?: Subscription_ManagementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_ManagementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion des abonnements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnementverwaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione degli abbonamenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление подписками")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de suscripciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("订阅管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプション管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता प्रबंधन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gestão de Assinaturas")
	return /** @type {LocalizedString} */ ("Subscription Management")
});